import Visibility from '@mui/icons-material/Visibility';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useGenerateDocumentFromTemplate } from './useGenerateDocumentFromTemplate';
import { LoadingButton } from 'components/loadingbutton/LoadingButton';
import { COLORS } from 'muiTheme/colors';

interface TemplateActionsProps {
  contentId: string;
}

export function TemplateActions({ contentId }: TemplateActionsProps) {
  const { t } = useTranslation();
  const { generateDocumentHandle, isLoading } = useGenerateDocumentFromTemplate({ assetData: { content_id: contentId } });

  return (
    <div className="buttons-container">
      <Button
        startIcon={<Visibility />}
        variant="outlined"
        color="primary"
        onClick={() => {
          window.open(`/template/${contentId}`, '_blank');
        }}
      >
        Preview
      </Button>
      <LoadingButton isLoading={isLoading} onClick={generateDocumentHandle}>
        <Typography variant="body2" fontWeight={600} color={COLORS.white}>
          {t('editor.editor_menu.generate_document')}
        </Typography>
      </LoadingButton>
    </div>
  );
}
